import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d7ca92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center mb-2 result-search" }
const _hoisted_2 = { class: "fs-8" }
const _hoisted_3 = {
  key: 0,
  class: "fs-8 d-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("中")
const _hoisted_5 = { class: "number ps-2 fw-bold pe-1 fs-5 mb-1" }

import { translate } from '@/languages/i18n'
import { numberWithCommas } from '@/constants/common.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  totalRecords: Number,
  totalChecked: Number,
  isChecked: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(translate)('CC10numberResults', _unref(numberWithCommas)(__props.totalRecords) || '0')), 1),
    (__props.isChecked)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(numberWithCommas)(__props.totalChecked)), 1),
          _createTextVNode(_toDisplayString(_unref(translate)('selectItem')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})